<div class="sidebar-overlay"
	 [class.open]="isOpen"
	 (click)="onClose()">
</div>

<div class="sidebar flex flex-column" [class.open]="isOpen">
	<div class="p-4 border-bottom-1 surface-border surface-0">
		<div class="flex justify-content-between align-items-center">
			<div class="flex align-items-center gap-4">
				<div class="flex align-items-center gap-3">
					<mat-icon class="ride-icon">{{ headerIcon }}</mat-icon>
					<h2 class="ride-title m-0 text-2xl font-semibold text-color">Ride #{{ orderId || '--' }}</h2>
				</div>
				<div *ngIf="isRefreshing" class="flex align-items-center justify-content-center h-full">
					<mat-spinner diameter="28" strokeWidth="3" color="accent"></mat-spinner>
				</div>
			</div>
			<button mat-icon-button (click)="onClose()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>

	<div *ngIf="loading" class="flex flex-column align-items-center justify-content-center flex-1 p-6">
		<mat-card class="p-6 text-center border-round-lg shadow-2 surface-0" appearance="outlined">
			<mat-card-content class="flex flex-column align-items-center gap-4">
				<mat-spinner diameter="50"></mat-spinner>
				<p class="m-0 text-color-secondary font-medium">Loading order details...</p>
			</mat-card-content>
		</mat-card>
	</div>

	<div *ngIf="loadFailed" class="flex flex-column align-items-center justify-content-center flex-1 p-6">
		<mat-card class="p-6 text-center border-round-lg shadow-2 surface-0 error-card-width" appearance="outlined">
			<mat-card-content class="flex flex-column align-items-center gap-3">
				<mat-icon class="error-icon">error_outline</mat-icon>
				<h3 class="m-0 text-xl font-semibold text-color">Failed to load order details</h3>
				<p class="m-0 text-sm text-color-secondary line-height-3">There was an error loading the order information. Please try again.</p>
				<button mat-raised-button class="flex align-items-center gap-2 mt-2 retry-button" (click)="retryLoad()">
					<mat-icon>refresh</mat-icon>
					Retry
				</button>
			</mat-card-content>
		</mat-card>
	</div>

	<app-tab-container *ngIf="!loading && !loadFailed" class="sidebar-tabs flex-1 overflow-hidden flex flex-column"
					   [selectedIndex]="selectedTabIndex"
					   (tabChange)="onTabChange($event)">

		<app-tab-item *ngIf="isTabVisible(BookingDetailTab.Details)" label="Details">
			<div class="p-4 h-full overflow-auto">
				<booking-details-tab [deliveryOrderDetails]="deliveryOrderDetails"></booking-details-tab>
			</div>
		</app-tab-item>

		<app-tab-item *ngIf="isTabVisible(BookingDetailTab.CustomerProfile)" label="Customer Profile">
			<div class="p-4 h-full overflow-auto">
				<booking-customer-profile-tab [deliveryOrderDetails]="deliveryOrderDetails"></booking-customer-profile-tab>
			</div>
		</app-tab-item>

		<app-tab-item *ngIf="isTabVisible(BookingDetailTab.People)" label="People">
			<div class="p-4 h-full overflow-auto">
				<booking-people-tab [deliveryOrderDetails]="deliveryOrderDetails"></booking-people-tab>
			</div>
		</app-tab-item>

		<app-tab-item *ngIf="isTabVisible(BookingDetailTab.Payment)" label="Payment">
			<div class="p-4 h-full overflow-auto">
				<booking-payment-tab [deliveryOrderDetails]="deliveryOrderDetails"></booking-payment-tab>
			</div>
		</app-tab-item>

		<app-tab-item *ngIf="isTabVisible(BookingDetailTab.Messages)" label="Messages">
			<div class="p-4 h-full overflow-auto">
				<booking-messages-tab [deliveryOrderDetails]="deliveryOrderDetails"></booking-messages-tab>
			</div>
		</app-tab-item>

		<app-tab-item *ngIf="isTabVisible(BookingDetailTab.Timeline)" label="Timeline">
			<div class="p-4 h-full overflow-auto">
				<booking-timeline-tab [deliveryOrderDetails]="deliveryOrderDetails"></booking-timeline-tab>
			</div>
		</app-tab-item>

		<app-tab-item *ngIf="isTabVisible(BookingDetailTab.Assigning)" label="Assigning">
			<div class="p-4 h-full overflow-auto">
				<booking-assigning-tab [orderId]="orderId"
									   [isActive]="selectedTabLabel === 'Assigning'">
				</booking-assigning-tab>
			</div>
		</app-tab-item>
	</app-tab-container>

	<div class="p-3 border-top-1 surface-border flex gap-3 justify-content-end" *ngIf="!loading && !loadFailed">
		<button *ngIf="isCancelButtonVisible()" mat-raised-button color="primary" class="cancel-button" (click)="onCancelTrip()">
			Cancel Trip
		</button>
		<button *ngIf="isCompleteButtonVisible()" mat-raised-button color="primary" class="complete-button" (click)="onCompleteTrip()">
			Complete Trip
		</button>
		<button *ngIf="isForceAssignVisible()" mat-raised-button color="primary" class="force-assign-button" (click)="onForceAssign()">
			Force Assign
		</button>
		<button *ngIf="isPrioritizeRequestVisible()" mat-raised-button color="primary" class="prioritize-request-button" (click)="onPrioritizeRequest()">
			Prioritize Request
		</button>
	</div>
</div>
